import React from 'react';

interface IProps {
  className?: string;
  text: React.ReactElement | string;
  author: React.ReactElement | string;
}

export const Quote: React.FC<IProps> = ({ text, author }) => (
  <blockquote className='my-10 border-l-4 px-10 text-neutral-500'>
    <p>"{text}"</p>
    <cite className='ml-10'>- {author}</cite>
  </blockquote>
);
